/* eslint-disable no-throw-literal */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import AuthContext from '../contexts/AuthContext';
import { AlertContext } from '../contexts/AlertContext';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import RangeSlider from 'react-bootstrap-range-slider';
import Row from 'react-bootstrap/Row';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import ProductImages from '../components/ProductImages';
import { Storage } from 'aws-amplify';
const convert = require('color-convert');
const tinifyKey = 'jtD50ZJLPwwbfNP8HwQZH2C4m2GkQSHY';

const ProductWebAssetForm = ({ collection, productSKU, productImages, isActive }) => {
  const location = useLocation();
  const { authState } = useContext(AuthContext);
  const { dispatch } = useContext(AlertContext);
  const closeAlert = () => dispatch({ type: 'close' }); // HACK: needed to pass reducer dispatch() func
  let hostname;
  switch (window.location.hostname) {
    case 'localhost':
    case '127.0.0.1':
      hostname = 'http://localhost:3000';
      break;
    case 'asset-lab-dev.facecake.com':
      hostname = 'https://cake-dev.facecake.com';
      break;
    default:
      hostname = 'https://cake.facecake.com';
      break;
  }
  let tryOnURL = `${hostname}/try-on/${collection}/${productSKU}?disable-cache=true`;
  const [activeCard, setActiveCard] = useState(
    authState.userPermissions.facecake ? 'refinements' : 'product-images'
  );
  const [productWebConfig, setProductWebConfig] = useState({});
  const [assetGLTFMeshes, setAssetGLTFMeshes] = useState([]);
  const [filesUploading, setFilesUploading] = useState(false);
  const [productHistory, setProductHistory] = useState({notes: [], internalNotes: []});
  const [newProductNote, setNewProductNote] = useState({note: ''});
  const notesType = collection === 'facecake' ? 'internalNotes' : 'notes';
  const [uploadTypes, setUploadTypes] = useState({web: true, ios: true, android: true});
  const [gltfFiles, setGLTFFiles] = useState();
  const startingAdjustments = useRef();
  const faceCakeIframe = document.querySelector('#facecake-try-on-iframe');
  let {
    adjustments,
    customThreeLights,
    environment,
    gltfURL,
    occluderURL,
    productId,
    productViewId,
    refinements,
    // scale,
    tryOnType,
  } = productWebConfig;
  const readOnly = authState?.userPermissions[collection]?.update === false;
  const userEmail = authState?.email;
  const userIsFaceCake = authState.userPermissions.facecake ? true : false;
  // XXX: event listener to handle posted messages from parent window
  window.addEventListener('message', (event) => {
    switch (event.data?.action) {
      case 'sendGLTFMeshes':
        const meshes = event.data?.gltfMeshes;
        setAssetGLTFMeshes(meshes);
        break;
      default:
        break;
    }
  });

  // XXX: get the product web config
  useEffect(() => {
    Storage.get(`p/${collection}/${productSKU}/metadata/web.json`, {
      download: true,
      cacheControl: 'no-cache',
    })
      .then((res) => {
        res.Body.text().then((resText) => {
          const S3ProductWebConfig = JSON.parse(resText);
          setProductWebConfig(S3ProductWebConfig);
          // assign object by VALUE, not by reference to keep the original starting values
          startingAdjustments.current = Object.assign(
            {},
            S3ProductWebConfig?.adjustments
          );
        });
      })
      .catch((err) => console.warn(err));
    Storage.get(`p/${collection}/${productSKU}/metadata/history.json`, {
      download: true,
      cacheControl: 'no-cache',
    })
      .then((res) => {
        res.Body.text().then((resText) => {
          setProductHistory(JSON.parse(resText));
        });
      })
      .catch((err) => {
        console.warn(err);
        setProductHistory({ notes: [], internalNotes: [] });
      });
  }, [location, collection, productSKU]);

  const toggleAccordion = (eventKey) => {
    // if toggling currently expanded, set to null so nothing is toggled; otherwise expand new card
    setActiveCard(eventKey === activeCard ? null : eventKey);
  };

  // XXX: general handleChange for normal form fields
  const handleChange = (e) => {
    const key = e.target.id;
    let value;
    if (
      [
        'adjustments',
        'customThreeLights',
        'environment',
        'refinements',
      ].includes(key)
    ) {
      value = JSON.parse(e.target.value);
    } else {
      value = e.target.value;
    }
    setProductWebConfig({ ...productWebConfig, [key]: value });
  };

  // XXX: save JSON to S3
  const writeJSON = async (object, s3Path, onSuccess) => {
    try {
      await Storage.remove(s3Path);
      const res = await Storage.put(s3Path, JSON.stringify(object, null, 2), {
        level: 'public',
        contentType: 'application/json',
        cacheControl: 'no-cache',
      });
      console.log('Product Web Config Updated:', res?.key);
      onSuccess();
    } catch (err) {
      console.warn('S3 write Error:', err);
      dispatch({
        type: 'danger',
        title: 'Web Config NOT Saved',
        message: `ERROR: ${err}`,
        onConfirm: closeAlert,
      });
    }
  };

  const handleSubmit = () => {
    const productWebConfigS3Path = `p/${collection}/${productSKU}/metadata/web.json`;
    writeJSON(productWebConfig, productWebConfigS3Path, () => dispatch({
        type: 'success',
        title: 'Web Config Saved',
        message: `Product Web Config saved. Click OK to`,
        onConfirm: () => {closeAlert(); window.location.reload()},
      }));
  };

  const handleProductNoteChange = (e) => {
    const timestamp = new Date();
    const createdDate = timestamp.toUTCString()
    setNewProductNote({
      note: e.target.value,
      createdDate,
      createdBy: userEmail,
    });
  }

  const handleSaveProductNote = () => {
    if (newProductNote.note === '') {
      dispatch({
        type: 'danger',
        title: 'Note NOT saved.',
        message: `Please enter some text before saving note.`,
        onConfirm: closeAlert,
      });
    } else {
      if (productHistory[notesType]) {
        productHistory[notesType].unshift(newProductNote); // add to top of array
      } else {
        productHistory[notesType] = [newProductNote]; // add to top of array
      }
      const productHistoryS3Path = `p/${collection}/${productSKU}/metadata/history.json`;
      writeJSON(productHistory, productHistoryS3Path, () => {
        setProductHistory(productHistory);
        setNewProductNote({ note: '' });
      });
    }
  };
  // XXX: functions for adjustments tab
  const simpleAdjustments = [
    { adjust: 'x', maxAdjustment: 0.5, incrementAmount: 0.01, faceCakeOnly: true, disabled: true },
    { adjust: 'y', maxAdjustment: 0.5, incrementAmount: 0.01, faceCakeOnly: false, disabled: false },
    { adjust: 'z', maxAdjustment: 0.5, incrementAmount: 0.01, faceCakeOnly: true, disabled: true },
    { adjust: 'yaw', maxAdjustment: 0.5, incrementAmount: 0.01, faceCakeOnly: true, disabled: false },
    { adjust: 'pitch', maxAdjustment: 0.5, incrementAmount: 0.01, faceCakeOnly: false, disabled: false },
    { adjust: 'roll', maxAdjustment: 0.5, incrementAmount: 0.01, faceCakeOnly: true, disabled: false },
    { adjust: 'scale', maxAdjustment: 0.1, incrementAmount: 0.002, faceCakeOnly: false, disabled: false },
  ];
  const incrementAdjustment = ({key, increment}) => {
    const { maxAdjustment, incrementAmount } = simpleAdjustments.find((el) => el.adjust === key);
    let newValue = adjustments[key] + (increment * incrementAmount);
    // handle min/max limits
    if (newValue > startingAdjustments.current[key] + maxAdjustment) {
      newValue = startingAdjustments.current[key] + maxAdjustment;
    } else if (newValue < startingAdjustments.current[key] - maxAdjustment) {
      newValue = startingAdjustments.current[key] - maxAdjustment;
    }
    adjustments[key] = newValue;
    faceCakeIframe.contentWindow.postMessage(
      {
        action: "updateAdjustments",
        target: "threeGlasses",
        adjustments: adjustments,
      },
      "*"
    );
    setProductWebConfig({
      ...productWebConfig,
      adjustments: { ...adjustments, [key]: newValue },
    });
  };
  const updateAdjustment = ({key, value}) => {
    adjustments[key] = value;
    faceCakeIframe.contentWindow.postMessage(
      {
        action: 'updateAdjustments',
        target: 'threeGlasses',
        adjustments: adjustments,
      },
      '*'
    );

    setProductWebConfig({
      ...productWebConfig,
      adjustments: { ...adjustments, [key]: value },
    });
  };

  // XXX: functions for refinements tab
  // array describes which refinements available to which meshType; plus a counter for later
  const meshTypes = {
    frame: {
      refinements: ['color', 'opacity', /* 'metalness', 'roughness' */],
      min: 0, max: 1, step: 0.01,
      count: 0,
    },
    frames: {
      refinements: ['color', 'opacity', /* 'metalness', 'roughness' */],
      min: 0, max: 1, step: 0.01,
      count: 0,
    },
    arms: {
      refinements: ['color', 'opacity', /* 'metalness', 'roughness' */],
      min: 0, max: 1, step: 0.01,
      count: 0,
    },
    lenses: {
      refinements: ['color', 'opacity', /* 'metalness', 'roughness' */],
      min: 0, max: 1, step: 0.01,
      count: 0,
    },
  };
  // loop through the GLTF meshes returned when rendering the 3D model
  const refinementMeshes = assetGLTFMeshes
    ?.map((refinementMesh) => {
      const meshType = Object.keys(meshTypes).find(
        (meshType) =>
          refinementMesh.name.toLowerCase().search(meshType.toLowerCase()) >= 0
      );

      if (meshType) {
        // increment the meshType counter and also use it for naming
        meshTypes[meshType].count += 1;

        return {
          ...refinementMesh,
          displayName: `${meshType.toUpperCase()} ${meshTypes[meshType].count}`,
          meshType,
        };
      } else {
        return null;
      }
    })
    .filter((el) => el); // filter out rows with unknown mesh types

  const updateRefinement = ({ mesh, refinement, value }) => {
    if (typeof refinements === 'undefined') {
      refinements = {};
    }
    if (refinements.hasOwnProperty(mesh) === false) {
      refinements[mesh] = {};
    }
    // convert color saturation to HSV
    if (refinement === 'color') {
      // first get the current HSV from the refinement
      let currentColor = refinements[mesh]?.[refinement];
      if (typeof(currentColor) === 'undefined') {
        currentColor = '0xFFFFFF';
      }
      let currentHSV;
      if (currentColor?.hasOwnProperty('r')) {
        const { r, g, b } = currentColor;
        currentHSV = convert.rgb.hsv(r * 255, g * 255, b * 255);
      } else {
        currentHSV = convert.hex.hsv(currentColor);
      }
      // then combine that with the new slider value
      const rgb = convert.hsv.rgb([
        value.hasOwnProperty('h') ? value.h * 360 : currentHSV[0],
        value.hasOwnProperty('s') ? value.s * 100 : currentHSV[1],
        value.hasOwnProperty('v') ? value.v * 100 : currentHSV[2],
      ]);
      refinements[mesh][refinement] = {
        r: rgb[0] / 255,
        g: rgb[1] / 255,
        b: rgb[2] / 255,
      };
    } else {
      refinements[mesh][refinement] = parseFloat(value);
    }
    setProductWebConfig({...productWebConfig, refinements: {...refinements}})
    faceCakeIframe.contentWindow.postMessage(
      {
        action: 'updateRefinements',
        target: 'threeGlasses',
        refinements: refinements,
      },
      '*'
    );
  };


  // XXX: functions for handling GLTF upload
  const handleUploadTypeChange = (e) => {
    let uploadType;
    switch (e.target.id) {
      case 'uploadIos':
        uploadType = 'ios';
        break;
      case 'uploadAndroid':
        uploadType = 'android';
        break;
      case 'uploadWeb':
      default:
        uploadType = 'web';
        break;
    }
    setUploadTypes({ ...uploadTypes, [uploadType]: e.target.checked });
  };
  const handleFileUpload = (e) => {
    setGLTFFiles(e.target.files);
  };
  const handleUploadGLTFFiles = async (gltfFiles, onSuccess) => {
    setFilesUploading(true);
    try {
      // upload if gltfFiles is not empty and there's at least .GLTF file in list
      if (gltfFiles?.length > 0) {
        // create folder under /models as ISO 8601 timestamp (except replace colons with underscores)
        let timestamp = new Date();
        timestamp =
          timestamp.toISOString().split('.')[0].replace(/[:]/g, '_') + 'Z';
        const rootGLTFFolder = `p/${collection}/${productSKU}/model/`;
        const newGLTFFolder = `${rootGLTFFolder}${timestamp}/`;
        // array for put promises
        let putPromises = [];
        // first write to selected model folders
        const uploadToFolders = [];
        for (const uploadType in uploadTypes) {
          if (uploadTypes[uploadType]) {
            uploadToFolders.push(uploadType);
          }
        }
        uploadToFolders.forEach(folder => {
          console.log(387, folder);
          console.log(rootGLTFFolder);
          const thisFolderPutPromises = Array.from(gltfFiles).map((file) => {
            let gltfURL = 'https://cdn.facecake.com/';
            let modelFolder = '';
            if (folder !== 'web') {
              modelFolder = `${folder}/`;
            }
            const extension = file?.name?.split('.')?.pop();
            if (extension === 'gltf') {
              gltfURL = `${gltfURL}${rootGLTFFolder}${
                file.name
              }?v=${Date.now().toString(36)}`;
              console.log('GLTF URL:', gltfURL);
              if (folder === 'web') {
                setProductWebConfig({
                  ...productWebConfig,
                  gltfURL: gltfURL,
                });
              }
            }
            // set content type for images
            let type;
            switch (extension) {
              case 'jpg, jpeg':
                type = 'image/jpeg';
                break;
              case 'png':
                type = 'image/png';
                console.log(417, file);
                break;
              case 'webp':
                type = 'image/webp';
                break;
              default:
                type = 'application/octet-stream';
                break;
            }
            return Storage.put(`${rootGLTFFolder}${modelFolder}${file.name}`, file, {
              level: 'public',
              contentType: type,
            });
          });
          putPromises = putPromises.concat(thisFolderPutPromises);
        });
        
        Promise.all(putPromises)
          .then((results) => {
            onSuccess && onSuccess();
          })
          .catch((err) => {
            throw err;
          });
        // write to NEW FOLDER so we have revision history
        const newFolderPutPromises = Array.from(gltfFiles).map((file) => {
          const extension = file?.name?.split('.')?.pop();
          // set content type for images
          let type;
          switch (extension) {
            case 'jpg, jpeg':
              type = 'image/jpeg';
              break;
            case 'png':
              type = 'image/png';
              break;
            case 'webp':
              type = 'image/webp';
              break;
            default:
              type = 'application/octet-stream';
              break
          }
          return Storage.put(`${newGLTFFolder}${file.name}`, file, {
            level: 'public',
            contentType: type,
          });
        });
        Promise.all(newFolderPutPromises)
          .then((results) => {
            onSuccess && onSuccess();
            setFilesUploading(false);
            // show alert modal
            dispatch({
              type: 'success',
              title: 'GLTF Folder Upload Successful',
              message: `GLTF files uploaded`,
              onConfirm: closeAlert,
            });
          })
          .catch((err) => {
            throw err;
          });
      } else {
        throw 'No .gltf file found';
      }
    } catch (err) {
      console.warn('S3 write Error:', err);
      // show alert modal
      dispatch({
        type: 'danger',
        title: 'GLTF Folder Upload Error',
        message: `ERROR: ${err}`,
        onConfirm: closeAlert,
      });
      setFilesUploading(false);
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col sm={12} md={4} lg={4} xl={4}>
          <Accordion
            defaultActiveKey={userIsFaceCake ? 'refinements' : 'product-images'}
          >
            <Card id='product-images'>
              <Accordion.Toggle
                as={Card.Header}
                eventKey='product-images'
                onClick={() => toggleAccordion('product-images')}
                style={{
                  backgroundColor:
                    activeCard === 'product-images'
                      ? 'var(--secondary-light)'
                      : 'var(--primary-light)',
                }}
              >
                PRODUCT IMAGES
                <div className='float-right'>
                  {activeCard === 'product-images' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey='product-images'>
                <Card.Body>
                  <ProductImages
                    productImages={productImages}
                    readOnly={true}
                  />
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card id='adjustments'>
              <Accordion.Toggle
                as={Card.Header}
                eventKey='adjustments'
                onClick={() => toggleAccordion('adjustments')}
                style={{
                  backgroundColor:
                    activeCard === 'adjustments'
                      ? 'var(--secondary-light)'
                      : 'var(--primary-light)',
                }}
              >
                ADJUSTMENTS
                <div className='float-right'>
                  {activeCard === 'adjustments' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey='adjustments'>
                <Card.Body>
                  <Form>
                    {simpleAdjustments.map(
                      ({ adjust, disabled, faceCakeOnly }) => {
                        const startingAdjustment = startingAdjustments.current
                          ? startingAdjustments.current[adjust]
                          : 0;
                        const {
                          maxAdjustment,
                          incrementAmount,
                        } = simpleAdjustments.find(
                          (el) => el.adjust === adjust
                        );
                        const min = startingAdjustment - maxAdjustment;
                        const max = startingAdjustment + maxAdjustment;
                        return (
                          <React.Fragment key={adjust}>
                            {faceCakeOnly === false || userIsFaceCake ? (
                              <Row>
                                <Col xs={12} sm={12}>
                                  <Form.Group
                                    controlId={`${adjust}`}
                                    className='mb-0'
                                  >
                                    <Form.Label
                                      column='sm'
                                      sm={12}
                                      className='pl-0'
                                    >
                                      {adjust.toUpperCase()}: &nbsp;
                                      {adjustments?.[adjust]?.toFixed(3)}
                                    </Form.Label>
                                    <Button
                                      style={{ marginTop: '-1rem' }}
                                      className='mr-1 px-2 py-0 small-text'
                                      disabled={disabled || readOnly}
                                      onClick={() =>
                                        incrementAdjustment({
                                          key: adjust,
                                          increment: -1,
                                        })
                                      }
                                    >
                                      &ndash;
                                    </Button>
                                    <RangeSlider
                                      className='width-xs-80 width-md-60 width-lg-70 width-xl-80'
                                      disabled={disabled || readOnly}
                                      tooltip='off'
                                      bsPrefix='custom-range'
                                      variant='primary'
                                      min={min}
                                      max={max}
                                      step={incrementAmount}
                                      value={adjustments?.[adjust] || 0}
                                      onChange={(e) => {
                                        updateAdjustment({
                                          key: adjust,
                                          value: parseFloat(e.target.value),
                                        });
                                      }}
                                    />
                                    <Button
                                      style={{ marginTop: '-1rem' }}
                                      className='ml-1 px-2 py-0 small-text'
                                      disabled={disabled || readOnly}
                                      onClick={() =>
                                        incrementAdjustment({
                                          key: adjust,
                                          increment: 1,
                                        })
                                      }
                                    >
                                      +
                                    </Button>
                                  </Form.Group>
                                </Col>
                              </Row>
                            ) : null}
                          </React.Fragment>
                        );
                      }
                    )}
                  </Form>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {userIsFaceCake && (
              <Card id='refinements'>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey='refinements'
                  onClick={() => toggleAccordion('refinements')}
                  style={{
                    backgroundColor:
                      activeCard === 'refinements'
                        ? 'var(--secondary-light)'
                        : 'var(--primary-light)',
                  }}
                >
                  REFINEMENTS
                  <div className='float-right'>
                    {activeCard === 'refinements' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey='refinements'>
                  <Card.Body>
                    <Form>
                      {refinementMeshes?.length > 0 ? (
                        refinementMeshes?.map(
                          ({ name, displayName, meshType }) => (
                            <React.Fragment key={name}>
                              {displayName}
                              {meshTypes[meshType].refinements.map(
                                (refinement, i) => {
                                  let value = refinements?.[name]?.[refinement];
                                  // if refinement is color then it returns an object in the
                                  // shape of {r, g, b} so convert it to HSV and use saturation
                                  // as the value for slider
                                  if (refinement === 'color') {
                                    let hsv;
                                    if (value) {
                                      if (value.hasOwnProperty('r')) {
                                        const { r, g, b } = value;
                                        // three JS uses 0 to 1 for RGB so multiply by 255
                                        hsv = convert.rgb.hsv(
                                          r * 255,
                                          g * 255,
                                          b * 255
                                        );
                                      } else {
                                        hsv = convert.hex.hsv(value);
                                      }
                                      // then divide hsv by 100 so it's between 0 and 1
                                      value = {
                                        h: hsv[0] / 360,
                                        s: hsv[1] / 100,
                                        v: hsv[2] / 100,
                                      };
                                    } else {
                                      value = { h: 0, s: 0, v: 1 };
                                    }
                                  } else {
                                    if (!value) {
                                      value = 1;
                                    }
                                  }
                                  return (
                                    <Row key={refinement} className='py-0'>
                                      <Col xs={12} sm={12}>
                                        <Form.Group
                                          controlId={`${name}::${refinement}`}
                                          className='mb-0'
                                        >
                                          <Form.Label
                                            column='sm'
                                            sm={12}
                                            className='pl-0'
                                          >
                                            {`${refinement.toUpperCase()}${
                                              refinement === 'color'
                                                ? ' (Hue/Saturation/Brightness)'
                                                : ''
                                            }`}
                                            : &nbsp;
                                            {/* {adjustments?.[adjust]} */}
                                          </Form.Label>
                                          {/* <Form.Control
                                          disabled={readOnly}
                                          type="range"
                                          custom
                                          onClick={updateRefinement}
                                        />
                                        {name} {refinement} */}

                                          {refinement === 'color' ? (
                                            ['h', 's', 'v'].map((el) => (
                                              <RangeSlider
                                                key={el}
                                                id={`${name}::${refinement}`}
                                                variant='primary'
                                                min={0}
                                                max={1}
                                                step={0.01}
                                                tooltip='off'
                                                value={
                                                  value?.hasOwnProperty(el)
                                                    ? value[el].toFixed(2)
                                                    : ''
                                                }
                                                onChange={(e) =>
                                                  updateRefinement({
                                                    mesh: name,
                                                    refinement,
                                                    value: {
                                                      [el]: e.target.value,
                                                    },
                                                  })
                                                }
                                              />
                                            ))
                                          ) : (
                                            <RangeSlider
                                              id={`${name}::${refinement}`}
                                              variant='primary'
                                              min={0}
                                              max={1}
                                              step={0.01}
                                              value={value}
                                              onChange={(e) =>
                                                updateRefinement({
                                                  mesh: name,
                                                  refinement,
                                                  value: e.target.value,
                                                })
                                              }
                                            />
                                          )}
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                  );
                                }
                              )}
                            </React.Fragment>
                          )
                        )
                      ) : (
                        <div>Loading refinements...</div>
                      )}
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
            {userIsFaceCake && (
              <Card id='upload-gltf'>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey='upload-gltf'
                  onClick={() => toggleAccordion('upload-gltf')}
                  style={{
                    backgroundColor:
                      activeCard === 'upload-gltf'
                        ? 'var(--secondary-light)'
                        : 'var(--primary-light)',
                  }}
                >
                  UPLOAD NEW GLTF
                  <div className='float-right'>
                    {activeCard === 'upload-gltf' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey='upload-gltf'>
                  <Card.Body>
                    <Form>
                      <Form.Group>
                        <Form.Control
                          disabled={filesUploading}
                          id='upload-product-image'
                          type='file'
                          multiple
                          label='File'
                          onChange={handleFileUpload}
                        />{' '}
                      </Form.Group>
                      <Form.Group>
                        <Form.Check
                          type='checkbox'
                          label='Web'
                          id='uploadWeb'
                          checked={uploadTypes.web}
                          onChange={handleUploadTypeChange}
                        />
                        <Form.Check
                          type='checkbox'
                          label='iOS'
                          id='uploadIos'
                          checked={uploadTypes.ios}
                          onChange={handleUploadTypeChange}
                        />
                        <Form.Check
                          type='checkbox'
                          label='Android'
                          id='uploadAndroid'
                          checked={uploadTypes.android}
                          onChange={handleUploadTypeChange}
                        />
                      </Form.Group>
                    </Form>
                    <Button
                      // disable if not uploadTypes checked
                      disabled={Object.values(uploadTypes).includes(true) === false}
                      variant={filesUploading ? 'secondary' : 'primary'}
                      onClick={() => handleUploadGLTFFiles(gltfFiles, null)}
                    >
                      {filesUploading
                        ? 'Uploading...'
                        : 'Upload New GLTF Files'}
                    </Button>
                    <Row>
                      <Col xs={12}>
                        <small>
                          (NOTE: Pressing "Upload New GLTF Files" will upload
                          files to a new folder, but will NOT update web config
                          until "Save Web Config" is pressed.)
                        </small>
                      </Col>
                    </Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
            {userIsFaceCake && (
              <Card id='raw-web-config'>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey='raw-web-config'
                  onClick={() => toggleAccordion('raw-web-config')}
                  style={{
                    backgroundColor:
                      activeCard === 'raw-web-config'
                        ? 'var(--secondary-light)'
                        : 'var(--primary-light)',
                  }}
                >
                  RAW WEB CONFIG
                  <div className='float-right'>
                    {activeCard === 'raw-web-config' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey='raw-web-config'>
                  <Card.Body>
                    <Form>
                      <Form.Row>
                        <Form.Group as={Col} controlId='productId'>
                          <Form.Label>FaceCake Product ID</Form.Label>
                          <Form.Control
                            type='text'
                            placeholder='Enter product ID'
                            value={productId || ''}
                            readOnly={readOnly}
                            onChange={handleChange}
                          />
                        </Form.Group>

                        <Form.Group as={Col} controlId='productViewId'>
                          <Form.Label>Product View ID</Form.Label>
                          <Form.Control
                            type='text'
                            placeholder='Enter product view ID'
                            value={productViewId || ''}
                            readOnly={readOnly}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Form.Row>

                      {authState?.userGroups?.includes('facecake/admin') && (
                        <>
                          <Form.Row>
                            <Form.Group as={Col} controlId='tryOnType'>
                              <Form.Label>Try-On Type</Form.Label>
                              <Form.Control
                                type='text'
                                value={tryOnType || ''}
                                onChange={handleChange}
                              />
                            </Form.Group>

                            <Form.Group as={Col} controlId='productViewId'>
                              &nbsp;
                            </Form.Group>
                          </Form.Row>

                          <Form.Row>
                            <Form.Group as={Col} controlId='gltfURL'>
                              <Form.Label>GLTF URL</Form.Label>
                              <Form.Control
                                type='text'
                                placeholder='Enter GLTF URL'
                                value={gltfURL || ''}
                                onChange={handleChange}
                              />
                            </Form.Group>

                            <Form.Group as={Col} controlId='occluderURL'>
                              <Form.Label>Occluder URL</Form.Label>
                              <Form.Control
                                type='text'
                                placeholder='Enter occluder URL'
                                value={occluderURL || '' || ''}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Form.Row>

                          <Form.Row>
                            <Form.Group as={Col} controlId='adjustments'>
                              <Form.Label>Adjustments</Form.Label>
                              <Form.Control
                                as='textarea'
                                rows={5}
                                className='smaller-text'
                                value={
                                  JSON.stringify(adjustments, null, 2) || ''
                                }
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Form.Row>

                          <Form.Row>
                            <Form.Group as={Col} controlId='refinements'>
                              <Form.Label>Refinements</Form.Label>
                              <Form.Control
                                as='textarea'
                                rows={5}
                                className='smaller-text'
                                value={
                                  JSON.stringify(refinements, null, 2) || ''
                                }
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Form.Row>

                          <Form.Row>
                            <Form.Group as={Col} controlId='environment'>
                              <Form.Label>Environment</Form.Label>
                              <Form.Control
                                as='textarea'
                                rows={5}
                                className='smaller-text'
                                value={JSON.stringify(environment, null, 2)}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Form.Row>

                          <Form.Row>
                            <Form.Group as={Col} controlId='customThreeLights'>
                              <Form.Label>Custom Lights</Form.Label>
                              <Form.Control
                                as='textarea'
                                rows={5}
                                className='smaller-text'
                                value={JSON.stringify(
                                  customThreeLights,
                                  null,
                                  2
                                )}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Form.Row>
                        </>
                      )}
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
          </Accordion>
        </Col>
        {/* XXX: Try-On col */}
        <Col sm={12} md={6} lg={5} xl={collection === 'facecake' ? 4 : 4}>
          {gltfURL && isActive && (
            <iframe
              id='facecake-try-on-iframe'
              src={tryOnURL}
              title='Try-On'
              frameBorder='0'
              scrolling='no'
              allow='microphone; camera'
              style={{
                maxWidth: '482px',
                width: '482px',
                height: '482px',
                border: '1px solid #000000',
              }}
            ></iframe>
          )}
          <br />
          <br />
          <Form.Row className='mx-auto float-left'>
            {/* <Button
              variant={readOnly ? 'outline-secondary' : 'outline-primary'}
              disabled={readOnly}
            >
              Reset
            </Button> */}
            &nbsp;&nbsp;
            <Button
              variant={readOnly ? 'secondary' : 'primary'}
              disabled={readOnly}
              onClick={handleSubmit}
            >
              Save Web Config
            </Button>
          </Form.Row>
        </Col>
        <Col sm={12} md={12} lg={3} xl={4} className='pl-lg-4'>
          <nav aria-label='Product Notes' className='mb-0'>
            <ol className='breadcrumb mb-1 pb-1'>
              <li className='breadcrumb-item active'>
                {notesType === 'internalNotes' && (
                  <strong>INTERNAL&nbsp;</strong>
                )}
                PRODUCT NOTES
              </li>
            </ol>
          </nav>
          <Card className='mb-2'>
            <Card.Body className='py-1 px-2'>
              <Card.Text>
                <Form.Group as='span' controlId='newProductNote'>
                  <Form.Control
                    as='textarea'
                    rows={5}
                    value={newProductNote.note}
                    onChange={handleProductNoteChange}
                  />
                </Form.Group>
              </Card.Text>
            </Card.Body>
            <Card.Footer className='text-right py-1'>
              <span className='float-right mt-0 py-0'>
                <Button
                  onClick={handleSaveProductNote}
                  variant='primary'
                  className='py-0'
                >
                  Save Note
                </Button>
              </span>
            </Card.Footer>
          </Card>
          {productHistory[notesType]?.map(
            ({ note, createdDate, createdBy }, i) => (
              <Card key={i} className='my-2'>
                <Card.Header className='text-right py-0'>
                  <span className='float-left'>
                    <small>{createdDate}</small>
                  </span>
                  <span className='float-right'>
                    <small>{createdBy}</small>
                  </span>
                </Card.Header>
                <Card.Body className='py-0'>
                  <Card.Text>{note}</Card.Text>
                </Card.Body>
              </Card>
            )
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ProductWebAssetForm;